import { SyncAction } from '@shared/models/sync/sync-action';
import { SyncActionGroup } from '../models/sync-action-group';
import { toRefKey } from './to-ref-key';

// Groups flat synced children by their parent. Insertion order is preserved: a group appears where
// its first child was first seen, and children keep their order within the group.
export const groupSyncActionsByParent = (actions: SyncAction[]): SyncActionGroup[] => {
  const groups = new Map<string, SyncActionGroup>();
  for (const action of actions) {
    const key = toRefKey(action.object.parent);
    const group = groups.get(key);
    if (group) {
      group.children.push(action);
    } else {
      groups.set(key, { parent: action.object.parent, children: [action] });
    }
  }
  return [...groups.values()];
};
